import { z } from "zod";

const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const editSocialNetworkSchema = z.object({
  facebook: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^https:\/\/(www\.)?facebook\.com\//.test(val),
      "L'URL doit commencer par https://facebook.com/ ou https://www.facebook.com/",
    ),

  linkedin: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^https:\/\/(www\.)?linkedin\.com\//.test(val),
      "L'URL doit commencer par https://linkedin.com/ ou https://www.linkedin.com/",
    ),

  x: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^https:\/\/(www\.)?x\.com\//.test(val),
      "L'URL doit commencer par https://x.com/ ou https://www.x.com/",
    ),

  messaging: z
    .string()
    .optional()
    .refine((val) => !val || isValidUrl(val), "L'URL n'est pas valide"),
});

export type editSocialNetworkSchemaValues = z.infer<
  typeof editSocialNetworkSchema
>;
